export default __webpack_public_path__ + "static/media/airstrapz-bpk-banner-2.de4bad29.jpg";